export default "__VITE_ASSET__ZiZHF4i2__"